import * as React from 'react';
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { Navbar } from "../../Common/Components/Navbar";
import { Stepper } from "./Components/Stepper";
import { alertController } from "../../Common/Controllers/AlertController";
import { userAccountController } from "../../Common/Controllers/UserAccountController";

export const CheckoutPage = observer(() => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!userAccountController.isLoggedIn && !userAccountController.isUserAccountDataLoading) {
      alertController.displayAlert(
        "Login required",
        "You have to be logged in in order to view this page.",
        "warning",
        4000
      )
      navigate("/latest");
    }
  }, [userAccountController.isLoggedIn])

  return (
    <div className={"flex flex-col"}>
      <Navbar isBasketIconEnabled={false} isAccountIconEnabled={true} isSearchable={false} isInline={true} />
      <div className="flex flex-col flex-grow h-[calc(100vh-66px)] mdh:h-[calc(100vh-114px)] lgh:h-[calc(100vh-130px)]">
        <Stepper />
        <Outlet />
      </div>
    </div>
  )
})